import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IApplicationContent } from '../types/content.type';
import { INearbySchool } from '../types/nearby-school.type';
import { ISchool } from '../types/school.type';
import { IAppSettings, APP_CONFIG } from '@nha/config/interfaces/iapp-settings.interface';

@Injectable()
export class ContentService {
	appSettings = inject<IAppSettings>(APP_CONFIG);
	serviceUrl = this.appSettings.api.application;
	constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

	getContent(schoolID: number, culture: string): Observable<IApplicationContent> {
		return this.http.get<IApplicationContent>(`${this.serviceUrl}/content?schoolId=${schoolID}&culture=${culture}`);
	}

	getAllSchools(culture: string): Observable<ISchool[]> {
		return this.http.get<ISchool[]>(`${this.serviceUrl}/schools/all?culture=${culture}`);
	}

	getAllSchoolsBySchoolId(schoolID: number, culture: string): Observable<ISchool[]> {
		return this.http.get<ISchool[]>(`${this.serviceUrl}/schools/allSchoolsBySchoolId?schoolId=${schoolID}&culture=${culture}`);
	}

	getNearbySchools(lat: number, lng: number, culture: string): Observable<INearbySchool[]> {
		return this.http.get<INearbySchool[]>(`${this.serviceUrl}/schools/nearby?lat=${lat}&lng=${lng}&culture=${culture}`);
	}

	getTermsConditions(stateCode: string, culture: any): Observable<SafeHtml> {
		return this.http
			.get(
				`${this.serviceUrl}/content/termsconditions?stateCode=${stateCode}&culture=${culture}`,

				{
					headers: {
						Accept: 'text/html'
					},
					responseType: 'text'
				}
			)
			.pipe(
				map((response: string) => {
					return <any>this.sanitizer.bypassSecurityTrustHtml(response.replace(/(\"\t\r\n|\n|\r|\t|\")/gm, '').replace('<br>', ''));
				})
			);
	}
}
